import { AddRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Logo } from '@icons';
import { motion } from 'motion/react';
import { useState } from 'react';
import classnames from 'classnames';
import Image from 'next/image';

export default function Divider({ title, subtitle, img, cta }) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div
      className={classnames(
        'relative',
        'flex',
        'flex-col',
        'md:w-screen md:mx-auto',
        'my-10',
        'overflow-hidden',
        'centered',

        'h-[100vw] md:h-[80vh]',
      )}
    >
      <div
        className={classnames(
          'flex flex-col items-center h-full justify-center capitalize text-center text-neutral',
        )}
      >
        <Logo
          className={classnames(
            'w-10 h-10 md:w-20 md:h-20 fill-neutral',
          )}
        />

        <span className="h1">{title}</span>
        <span className="h1">{subtitle}</span>
        {cta && (
          <div className="mt-4 md:mt-8">
            <Button variant="contained" href={cta?.href}>
              <AddRounded className="mr-2" />
              <span>{cta?.label}</span>
            </Button>
          </div>
        )}
      </div>
      <div className={classnames('')} />

      {/* Animated Background Image */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        className="absolute top-0 left-0 w-full h-full -z-20"
      >
        <Image
          src={img?.data?.attributes?.url}
          alt={title || 'Background'}
          fill
          priority // ensures eager loading instead of lazy
          style={{ objectFit: 'cover' }}
          className="brightness-[0.65]"
          onLoadingComplete={() => setIsLoaded(true)}
        />
      </motion.div>
    </div>
  );
}
